module.exports = __webpack_public_path__ + "static/media/default_audio.b7f60c25.jpg";